var arrayPush = require("./_arrayPush"), getPrototype = require("./_getPrototype"), getSymbols = require("./_getSymbols"), stubArray = require("./stubArray");
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
module.exports = getSymbolsIn;
